(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knorshot-b2b-reorder"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kb2b-step]');
    if (!button) return;
    var input = button.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(button.getAttribute('data-kb2b-step'), 10);
    input.value = Math.max(1, next);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
